
import { httpGet, httpPost } from "../Web";
import { ApiResponse } from "./ApiResponse";
import { Interface } from "./Interface";

export interface TestCombination {
    id?: number,
    combinationName?: string,
    combinationProvider?: string,
    combinationConsumer?: string,
    status?: TestCombinationStatus,
    guid?: string
};

export interface TestCombinationInterfaces {
    testCombination: TestCombination,
    interfaces: Interface[]
};

export interface TestComboSupportVal {
    id?: number,
    testCombinationId?: number,
    interfaceId?: number,
    testCaseId?: number,
    interfacePropertyId?: number,
};

export enum TestCombinationStatus {
    Draft = 0, Released = 1, Disabled = 2
}

export const TestCombinationStatusStrings = ["Draft", "Released", "Disabled"];

export const getTestCombinationList = (abortController: AbortController): Promise<ApiResponse<TestCombination[]>> => httpGet('/api/interface/GetTestCombinationList/', abortController);
export const getTestCombination = (id: number, abortController: AbortController): Promise<ApiResponse<TestCombination>> => httpGet(`/api/interface/GetTestCombination/${id}`, abortController);
export const updateTestCombination = (data: TestCombination, abortController: AbortController): Promise<ApiResponse<TestCombination>> => httpPost(`/api/interface/updateTestCombination`, data, abortController);
export const deleteTestCombination = (id: number, abortController: AbortController): Promise<ApiResponse<TestCombination>> => httpGet(`/api/interface/deleteTestCombination/${id}`, abortController);

export const gettestcombinationinterfaceslist = (abortController: AbortController): Promise<ApiResponse<TestCombinationInterfaces[]>> => httpGet('/api/interface/gettestcombinationinterfaceslist/', abortController);

export const getTestComboSupport = (data: TestComboSupportVal, abortController: AbortController): Promise<ApiResponse<TestComboSupportVal[]>> => httpPost('/api/interface/GetTestComboSupport/', data, abortController);
export const updateTestComboSupport = (data: TestComboSupportVal, abortController: AbortController): Promise<ApiResponse<TestComboSupportVal>> => httpPost(`/api/interface/updateTestComboSupport`, data, abortController);
export const deleteTestComboSupport = (id: number, abortController: AbortController): Promise<ApiResponse<TestComboSupportVal>> => httpGet(`/api/interface/deleteTestComboSupport/${id}`, abortController);
